import React, { createContext, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Backdrop from "@material-ui/core/Backdrop";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";

import { auth, messaging } from "../../../shared/services/firebase";

export const Context = createContext();

const AlertDialog = function ({ setAlertOpen }) {
  const [open, setOpen] = React.useState(true);
  const { t } = useTranslation("Authentication");

  const handleClickAgree = () => {
    const turnOnNotification = async () => {
      messaging
        .getToken()
        .then(() => {
          if ("serviceWorker" in navigator) {
            navigator.serviceWorker.ready.then((registration) => {
              registration.active.postMessage({ action: "updateToken" });
            });
          }
        })
        .catch((err) => {
          console.log("An error occurred while retrieving token. ", err);

          if (err.code === "messaging/token-unsubscribe-failed")
            turnOnNotification();
        });
    };

    turnOnNotification();

    setOpen(false);
    setAlertOpen(false);
  };

  const handleClose = () => {
    localStorage.setItem("@c2s-go/notificationPermission", "denied");

    setOpen(false);
    setAlertOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableBackdropClick={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {t("notification.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {t("notification.terms")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {t("notification.disagree")}
        </Button>
        <Button onClick={handleClickAgree} color="primary" autoFocus>
          {t("notification.agree")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export function AuthenticationContext({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [pending, setPending] = useState(true);
  const [alertOpen, setAlertOpen] = useState(false);

  useEffect(() => {
    if ("Notification" in window) {
      const notificationPermission = localStorage.getItem(
        "@c2s-go/notificationPermission"
      );

      if (
        notificationPermission != "denied" &&
        Notification.permission == "default"
      ) {
        setAlertOpen(true);
      }

      const unregisterAuthObserver = auth.onAuthStateChanged((user) => {
        setCurrentUser(user);
        setPending(false);
      });

      return () => unregisterAuthObserver();
    }
  }, []);

  if (pending) {
    return (
      <Backdrop open={true}>
        <CircularProgress />
      </Backdrop>
    );
  }

  return (
    <React.Fragment>
      {currentUser && alertOpen && <AlertDialog setAlertOpen={setAlertOpen} />}
      <Context.Provider value={{ currentUser }}>{children}</Context.Provider>
    </React.Fragment>
  );
}
